module.exports = __webpack_public_path__ + "static/media/jackpot-inner-background.4533f647.png";